/* eslint-disable  @typescript-eslint/no-explicit-any */
import * as React from "react";
import { Box, FormControl, FormHelperText, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";

export interface InstanceType {
  value: string;
  label: string;
}

export const InstanceTypes: InstanceType[] = [
  { value: "t4g.small", label: "(2 vCPUs, 2 GB of RAM, supports 2 game-servers)" },
  { value: "t4g.medium", label: "(2 vCPUs, 4 GB of RAM, supports 8 game-servers)" },
  { value: "t4g.large", label: "(2 vCPUs, 8 GB of RAM, supports 20 game-servers)" },
  { value: "t4g.xlarge", label: "(4 vCPUs, 16 GB of RAM, supports 40 game-servers)" },
];

export interface InstanceTypePickerProps {
  onInstanceTypeSelected?: (instanceType: InstanceType) => void;
  selectRef?: React.Ref<any>;
  error?: string;
}

export const InstanceTypePicker = ({ onInstanceTypeSelected, selectRef, error }: InstanceTypePickerProps) => {
  const handleChange = (event: SelectChangeEvent) => {
    const selectedInstanceTypeValue = event.target.value;
    const instanceType = InstanceTypes.find((type) => type.value === selectedInstanceTypeValue);
    if (instanceType && onInstanceTypeSelected) {
      onInstanceTypeSelected(instanceType);
    }
  };

  return (
    <Box sx={{ width: "100%", mt: 1 }}>
      <FormControl sx={{ width: "100%" }} error={!!error}>
        <InputLabel id="instance-type-label">Instance Type</InputLabel>
        <Select
          labelId="instance-type-label"
          id="instance-type-selector"
          defaultValue=""
          inputRef={selectRef}
          label="Instance Type"
          onChange={handleChange}
        >
          {InstanceTypes.map((type) => (
            <MenuItem key={type.value} value={type.value}>
              {type.value} {type.label}
            </MenuItem>
          ))}
        </Select>
        {error && <FormHelperText error>{error}</FormHelperText>}
      </FormControl>
    </Box>
  );
};
